import styled from 'styled-components'

export const CompletedSubtitle = styled.div`
  font-size: 1.2em;
  color: #65666A;
  font-weight: bold;
  & a {
    color: #3D6666;
  }
`

export const CompletedText = styled.div`
  font-size: 1em;
  color: #65666A;
  & a {
    color: #3D6666;
  }
`